import React from 'react';
import { Alert, Snackbar as MUISnackbar } from '@mui/material';

import { useAppDispatch, useAppSelector } from '~/hooks/store';
import { setAlertMessage } from '~/store/ux';
import { selectUX } from '~/store/ux/selectors';

const Snackbar = () => {
  const dispatch = useAppDispatch();
  const ux = useAppSelector(selectUX);

  const closeAlert = React.useCallback(() => {
    dispatch(setAlertMessage(null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MUISnackbar
      open={!!ux.alertMessage}
      autoHideDuration={6000}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      onClose={closeAlert}
    >
      <Alert onClose={closeAlert} severity={ux.alertMessage?.severity} sx={{ width: '100%' }}>
        {ux.alertMessage?.message}
      </Alert>
    </MUISnackbar>
  );
};

export default Snackbar;
